import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useState, useCallback, useMemo, useEffect } from 'react';
import { RendererNext } from '..';
import { makeAvatar, makeAvatarStack, makeNativeUserPicker } from '../../components';
import { WebRuntime } from '../../web-runtime';
import { uncurlyUuid } from './utils';
export var UIKitRenderer = function UIKitRenderer(props) {
  var accountId = props.accountId,
    bridge = props.bridge,
    client = props.client,
    components = props.components,
    coreData = props.coreData,
    contextIds = props.contextIds,
    entryPoint = props.entryPoint,
    extension = props.extension,
    extensionData = props.extensionData,
    extensionViewData = props.extensionViewData,
    getContextToken = props.getContextToken,
    mentionProvider = props.mentionProvider,
    product = props.product,
    locale = props.locale,
    modalExtension = props.modalExtension,
    onForgeDocUpdated = props.onForgeDocUpdated,
    getThreeLOPrompt = props.getThreeLOPrompt,
    customBridgeMethods = props.customBridgeMethods,
    loadingComponent = props.loadingComponent,
    onError = props.onError,
    extensionPayload = props.extensionPayload;
  var cloudId = coreData.cloudId,
    workspaceId = coreData.workspaceId;
  var _useState = useState(undefined),
    _useState2 = _slicedToArray(_useState, 2),
    forgeDoc = _useState2[0],
    _setForgeDoc = _useState2[1];
  var _useState3 = useState(undefined),
    _useState4 = _slicedToArray(_useState3, 2),
    error = _useState4[0],
    setError = _useState4[1];
  var wiredComponents = useMemo(function () {
    return {
      Avatar: makeAvatar({
        client: client
      }),
      AvatarStack: makeAvatarStack({
        client: client
      }),
      UserPicker: makeNativeUserPicker(_objectSpread(_objectSpread({
        client: client,
        mentionProvider: mentionProvider,
        accountId: accountId
      }, workspaceId ? {
        cloudId: 'bitbucket'
      } : {
        cloudId: cloudId
      }), {}, {
        productAttributes: workspaceId ? {
          workspaceIds: [uncurlyUuid(workspaceId)]
        } : undefined,
        productKey: product
      }))
    };
  }, [accountId, client, cloudId, mentionProvider, product, workspaceId]);
  var getComponents = useCallback(function (defaults) {
    return _objectSpread(_objectSpread(_objectSpread({}, defaults), wiredComponents), components);
  }, [components, wiredComponents]);
  var handleError = useCallback(function (error) {
    if (onError) {
      onError(error.message);
    }
  }, [onError]);
  useEffect(function () {
    if (onError && error) {
      onError(error.message);
    }
  }, [error, onError]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RendererNext, {
    isNative: true,
    forgeDoc: forgeDoc,
    extension: extension,
    error: error === null || error === void 0 ? void 0 : error.message,
    components: getComponents,
    modalExtension: modalExtension,
    extensionType: extensionData.type,
    loading: true,
    loadingComponent: loadingComponent,
    onError: handleError
  }), /*#__PURE__*/React.createElement(WebRuntime, {
    accountId: accountId,
    setForgeDoc: function setForgeDoc(forgeDoc) {
      if (forgeDoc.type !== 'MacroConfig') {
        _setForgeDoc(forgeDoc);
      }
      onForgeDocUpdated === null || onForgeDocUpdated === void 0 || onForgeDocUpdated(forgeDoc);
    },
    setError: setError,
    apolloClient: client,
    components: getThreeLOPrompt,
    contextIds: contextIds,
    extension: extension,
    coreData: coreData,
    extensionData: extensionData,
    extensionPayload: extensionPayload,
    extensionViewData: extensionViewData,
    locale: locale,
    bridge: bridge,
    getContextToken: getContextToken,
    entryPoint: entryPoint,
    customBridgeMethods: customBridgeMethods
  }));
};